/**
 * Portugués. Cada clave es la frase tal como está escrita en español en el
 * código; lo que falte aquí se ve en español (ver src/lib/i18n.ts).
 */
const pt: Record<string, string> = {
  // Menú y cabecera
  'Abrir menú': 'Abrir menu',
  'Cerrar menú': 'Fechar menu',
  'Buscar jugadores': 'Procurar jogadores',
  'Buscar…': 'Procurar…',
  'Entrar': 'Entrar',
  'Crear cuenta': 'Criar conta',
  'Cambiar a modo día': 'Mudar para o modo claro',
  'Cambiar a modo noche': 'Mudar para o modo escuro',
  'Modo día': 'Modo claro',
  'Modo noche': 'Modo escuro',
  'Mi perfil': 'Meu perfil',
  'Ajustes': 'Configurações',
  'Instalar la aplicación': 'Instalar o aplicativo',
  'Moderación': 'Moderação',
  'Cerrar sesión': 'Sair',
  'Reconectando con el servidor…': 'Reconectando ao servidor…',
  'Términos de uso': 'Termos de uso',
  'Preguntas frecuentes': 'Perguntas frequentes',
  'Idioma': 'Idioma',

  'Jugar': 'Jogar',
  'Crear partida en la sala de espera': 'Criar partida no saguão',
  'Desafía a un amigo': 'Desafie um amigo',
  'Torneos': 'Torneios',
  'Torneos suizos': 'Torneios suíços',
  'Partidas simultáneas': 'Simultâneas',
  'Tablero local': 'Tabuleiro local',
  'Ejercicios': 'Problemas',
  'Ejercicios por temas': 'Problemas por tema',
  'Panel de ejercicios': 'Painel de problemas',
  'Racha': 'Sequência',
  'Tormenta': 'Tempestade',
  'Carrera': 'Corrida',
  'Maratón': 'Maratona',
  'De mis partidas': 'Das minhas partidas',
  'Aprender': 'Aprender',
  'Practicar': 'Praticar',
  'Coordenadas': 'Coordenadas',
  'Estudiar': 'Estudar',
  'Entrenadores': 'Treinadores',
  'Ver': 'Assistir',
  'UAChess TV': 'UAChess TV',
  'Partidas actuales': 'Partidas em andamento',
  'Retransmisiones': 'Transmissões',
  'Biblioteca de vídeos': 'Biblioteca de vídeos',
  'Comunidad': 'Comunidade',
  'Comunidades': 'Comunidades',
  'Clasificación': 'Classificação',
  'Foro': 'Fórum',
  'Blog': 'Blog',
  'Herramientas': 'Ferramentas',
  'Tablero de análisis': 'Tabuleiro de análise',
  'Aperturas': 'Aberturas',
  'Editor de tablero': 'Editor de tabuleiro',
  'Pareo de torneos': 'Emparceiramento de torneios',
  'Reloj de ajedrez': 'Relógio de xadrez',
  'Importar partida': 'Importar partida',
  'Búsqueda avanzada': 'Busca avançada',
  'Inicio': 'Início',
  'Táctica': 'Tática',
  'Estudios': 'Estudos',
  'TV': 'TV',

  // Portada
  'Juega al ajedrez. En serio.': 'Jogue xadrez. A sério.',
  'Partidas en todos los ritmos, análisis con motor, estudios, táctica por temas, torneos y comunidades con sus propias ligas. Gratis y sin anuncios.':
    'Partidas em todos os ritmos, análise com motor, estudos, tática por temas, torneios e comunidades com suas próprias ligas. Grátis e sem anúncios.',
  'Crear cuenta gratis': 'Criar conta grátis',
  'Ya tengo cuenta': 'Já tenho conta',
  'Todos los ritmos': 'Todos os ritmos',
  'Desde UltraBullet de 15 segundos hasta correspondencia de 14 días, con incremento Fischer, Bronstein o retardo simple.':
    'Do UltraBullet de 15 segundos à correspondência de 14 dias, com incremento Fischer, Bronstein ou atraso simples.',
  'Análisis de verdad': 'Análise de verdade',
  'Motor Stockfish en tu navegador: evaluación, mejores líneas e informe de precisión de cada partida.':
    'Stockfish no seu navegador: avaliação, melhores linhas e relatório de precisão de cada partida.',
  'Táctica a medida': 'Tática sob medida',
  'Entrena por temas concretos (clavadas, horquillas, mates) o en modo mixto ajustado a tu nivel.':
    'Treine temas concretos (cravadas, garfos, mates) ou no modo misto ajustado ao seu nível.',
  'Crea capítulos con variantes, anotaciones y flechas, y compártelos o edítalos en equipo.':
    'Crie capítulos com variantes, comentários e setas, e compartilhe ou edite em equipe.',
  'Mira en directo las mejores partidas en curso y las rondas de los torneos importantes.':
    'Assista ao vivo às melhores partidas em andamento e às rodadas dos grandes torneios.',
  'Comunidades y ligas': 'Comunidades e ligas',
  'Monta tu club con sus propios torneos, temporadas y clasificación interna.':
    'Monte seu clube com torneios, temporadas e classificação própria.',
  'Hola, {name}': 'Olá, {name}',
  '¿Qué te apetece hoy?': 'O que você quer fazer hoje?',
  'Jugar una partida': 'Jogar uma partida',
  'Busca rival o reta a un amigo.': 'Procure um adversário ou desafie um amigo.',
  'Entrenar táctica': 'Treinar tática',
  'Por temas o mixto.': 'Por temas ou misto.',
  'Analizar': 'Analisar',
  'Revisa una posición o una partida.': 'Revise uma posição ou uma partida.',
  'Partidas en directo.': 'Partidas ao vivo.',
  'Prepara aperturas y finales.': 'Prepare aberturas e finais.',
  'Clubes, ligas y torneos propios.': 'Clubes, ligas e torneios próprios.',
  'Jugar ahora': 'Jogar agora',
  'Contra el ordenador': 'Contra o computador',
  'Retar a un amigo': 'Desafiar um amigo',
  'Más ritmos y la sala de espera': 'Mais ritmos e a sala de espera',
  'Curso De Zero a Hero.': 'O curso De Zero a Hero.',
  'Blitz': 'Blitz',
  'Tus ratings': 'Seus ratings',

  // Entrar y crear cuenta
  'Vuelve al tablero donde lo dejaste.': 'Volte ao tabuleiro onde parou.',
  '¿Aún no tienes cuenta?': 'Ainda não tem conta?',
  'Crear una gratis': 'Crie uma grátis',
  'Usuario o correo': 'Usuário ou e-mail',
  'Contraseña': 'Senha',
  'Entrando…': 'Entrando…',
  'No se pudo iniciar sesión. Inténtalo de nuevo.': 'Não foi possível entrar. Tente novamente.',
  'Continuar con Google': 'Continuar com o Google',
  'o con tu cuenta': 'ou com sua conta',
  'Mostrar contraseña': 'Mostrar senha',
  'Ocultar contraseña': 'Ocultar senha',
  'Gratis y para siempre. Sin anuncios ni tableros de pago.': 'Grátis para sempre. Sem anúncios nem tabuleiros pagos.',
  '¿Ya tienes cuenta?': 'Já tem conta?',
  'Nombre de usuario': 'Nome de usuário',
  'Disponible': 'Disponível',
  'No disponible': 'Indisponível',
  'No disponible.': 'Indisponível.',
  'De 2 a 20 caracteres. Empieza por una letra.': 'De 2 a 20 caracteres. Começa com uma letra.',
  'Correo electrónico': 'E-mail',
  'País': 'País',
  'Sale junto a tu nombre y en las clasificaciones. Puedes dejarlo sin decir.':
    'Aparece junto ao seu nome e nas classificações. Pode deixar em branco.',
  'Mínimo 8 caracteres.': 'Mínimo de 8 caracteres.',
  'Creando cuenta…': 'Criando conta…',
  'No se pudo crear la cuenta. Inténtalo de nuevo.': 'Não foi possível criar a conta. Tente novamente.',
  'Al crear la cuenta aceptas los': 'Ao criar a conta você aceita os',
  'términos de uso': 'termos de uso',
  'Muy débil': 'Muito fraca',
  'Débil': 'Fraca',
  'Aceptable': 'Razoável',
  'Buena': 'Boa',
  'Excelente': 'Excelente',

  // Ajustes
  'Necesitas una cuenta': 'Você precisa de uma conta',
  'Inicia sesión para guardar tus ajustes en todos tus dispositivos.':
    'Entre para salvar suas configurações em todos os seus dispositivos.',
  'Perfil público': 'Perfil público',
  'Avatar ilustrado': 'Avatar ilustrado',
  'Foto de perfil activa': 'Foto de perfil ativa',
  'Avatar ilustrado activo': 'Avatar ilustrado ativo',
  'Avatar actual': 'Avatar atual',
  'En uso': 'Em uso',
  'Avatar diseñado': 'Avatar criado',
  'Sin avatar creado': 'Sem avatar personalizado',
  'Los demás jugadores ven tu fotografía.': 'Os outros jogadores veem sua foto.',
  'Los demás jugadores ven tu avatar ilustrado.': 'Os outros jogadores veem seu avatar ilustrado.',
  'Personaliza tu perfil público, aspecto del tablero, preferencias y seguridad.': 'Personalize seu perfil público, aparência do tabuleiro, preferências e segurança.',
  'Esta información será visible para otros jugadores en tu perfil público y partidas.': 'Esta informação será visível para outros jogadores em seu perfil público e partidas.',
  'Personaliza la textura del tablero y el estilo de las piezas. Los cambios se aplican al instante en todas tus partidas.': 'Personalize a textura do tabuleiro e o estilo das peças. As alterações são aplicadas instantaneamente em todas as suas partidas.',
  'Configura los avisos, ayudas visuales y comportamiento durante tus partidas.': 'Configure avisos, auxílios visuais e comportamento durante as partidas.',
  'Idioma y tema': 'Idioma e tema',
  'Configura el aspecto visual general y el idioma de la aplicación.': 'Configure a aparência visual geral e o idioma do aplicativo.',
  'Título federado': 'Título federado',
  'Seguridad': 'Segurança',
  'Seguridad y contraseña': 'Segurança e senha',
  'Actualiza tu clave de acceso periódicamente para mantener tu cuenta protegida.': 'Atualize sua senha periodicamente para manter sua conta protegida.',
  'Guardar cambios': 'Salvar alterações',
  'Avatar': 'Avatar',
  'Editar mi avatar': 'Editar meu avatar',
  'Crear mi avatar': 'Criar meu avatar',
  'Elige piel, peinado, ropa y accesorios.': 'Escolha pele, penteado, roupas e acessórios.',
  'Volver a mi avatar personalizado': 'Voltar ao meu avatar personalizado',
  // Foto de perfil
  'Elige una imagen.': 'Escolha uma imagem.',
  'No se pudo guardar la foto. Inténtalo otra vez.': 'Não foi possível salvar a foto. Tente novamente.',
  'No se pudo quitar la foto.': 'Não foi possível remover a foto.',
  'Tu foto de perfil': 'Sua foto de perfil',
  'Usar una foto': 'Usar uma foto',
  'Sube una imagen o hazte una foto con la cámara.': 'Envie uma imagem ou tire uma foto com a câmera.',
  'Subir foto': 'Enviar foto',
  'Hacer foto': 'Tirar foto',
  'Quitar foto': 'Remover foto',
  'No hay permiso para usar la cámara. Actívalo en el navegador o sube una foto.': 'Sem permissão para usar a câmera. Ative-a no navegador ou envie uma foto.',
  'Encuadra tu foto': 'Enquadre sua foto',
  'No se pudo abrir esa imagen. Prueba con un JPG o PNG.': 'Não foi possível abrir essa imagem. Tente um JPG ou PNG.',
  'Zoom': 'Zoom',
  'Arrastra la foto para colocarla dentro del círculo.': 'Arraste a foto para posicioná-la dentro do círculo.',
  'Cancelar': 'Cancelar',
  'Usar esta foto': 'Usar esta foto',
  'Cerrar': 'Fechar',
  '¿Sin foto? Usa tu avatar:': 'Sem foto? Use seu avatar:',
  'Al guardar, este avatar sustituirá a tu foto.': 'Ao salvar, este avatar substituirá sua foto.',
  'O usa un emoji:': 'Ou use um emoji:',
  'Nombre': 'Nome',
  '(opcional)': '(opcional)',
  'Cómo te llamas': 'Como você se chama',
  'Ciudad o región': 'Cidade ou região',
  'Por ejemplo: Santiago': 'Por exemplo: Santiago',
  'Biografía': 'Biografia',
  'Cuéntale algo al resto de jugadores.': 'Conte algo aos outros jogadores.',
  'Guardando…': 'Salvando…',
  'Guardar': 'Salvar',
  'Guardado.': 'Salvo.',
  'No se pudo guardar.': 'Não foi possível salvar.',
  'Se guarda en este dispositivo. Las partes que aún no están traducidas se ven en español.':
    'Fica salvo neste dispositivo. As partes ainda não traduzidas aparecem em espanhol.',
  'Modo de color': 'Modo de cor',
  'Se guarda en este dispositivo.': 'Fica salvo neste dispositivo.',
  'Como el sistema': 'Igual ao sistema',
  'Día': 'Claro',
  'Noche': 'Escuro',
  'Aspecto del tablero': 'Aparência do tabuleiro',
  'Los cambios se aplican al instante en todas tus partidas.': 'As mudanças valem na hora em todas as suas partidas.',
  'Preferencias de juego': 'Preferências de jogo',
  'Sonidos': 'Sons',
  'Jugadas, capturas, jaque y aviso de tiempo.': 'Lances, capturas, xeque e aviso de tempo.',
  'Vibración': 'Vibração',
  'Respuesta háptica en el móvil al mover.': 'Resposta tátil no celular ao mover.',
  'Resaltar la última jugada': 'Destacar o último lance',
  'Mostrar jugadas legales': 'Mostrar lances legais',
  'Puntos en las casillas a las que puede ir la pieza elegida.': 'Pontos nas casas para onde a peça escolhida pode ir.',
  'Barra de evaluación': 'Barra de avaliação',
  'Jugadores de la casa': 'Jogadores da casa',
  'Si nadie acepta tu búsqueda en unos segundos, emparejarte con una cuenta de UAChess que mueve un programa de ajedrez. Desactívalo para jugar solo contra personas.':
    'Se ninguém aceitar sua busca em alguns segundos, emparelhar você com uma conta da UAChess movida por um programa de xadrez. Desative para jogar só contra pessoas.',
  'Confirmar antes de rendirse': 'Confirmar antes de abandonar',
  'Décimas de segundo en el reloj': 'Décimos de segundo no relógio',
  'Se muestran cuando queda menos de un minuto.': 'Aparecem quando falta menos de um minuto.',
  'Velocidad de las animaciones': 'Velocidade das animações',
  'Sin animación': 'Sem animação',
  'Rápida': 'Rápida',
  'Rápido': 'Rápido',
  'Normal': 'Normal',
  'Lenta': 'Lenta',
  'Coordenadas del tablero': 'Coordenadas do tabuleiro',
  'Dentro de las casillas': 'Dentro das casas',
  'Fuera del tablero': 'Fora do tabuleiro',
  'Ocultas': 'Ocultas',
  'Coronación': 'Promoção',
  'Preguntar siempre': 'Perguntar sempre',
  'Coronar dama automáticamente': 'Promover a dama automaticamente',
  'Cambiar contraseña': 'Mudar senha',
  'Contraseña actual': 'Senha atual',
  'Nueva contraseña': 'Nova senha',
  'Cambiando…': 'Mudando…',
  'Contraseña actualizada. Se cerraron las demás sesiones.': 'Senha atualizada. As outras sessões foram encerradas.',
  'No se pudo cambiar.': 'Não foi possível mudar.',

  // Página que no existe
  'Jugada ilegal': 'Lance ilegal',
  'Esta página no existe o se movió de casilla.': 'Esta página não existe ou mudou de casa.',
  'Volver al inicio': 'Voltar ao início',

  // Tiempo relativo
  'hace un momento': 'agora mesmo',
  'hace {n} min': 'há {n} min',
  'hace {n} h': 'há {n} h',
  'hace {n} d': 'há {n} d',

  // De Zero a Hero
  'De Zero a Hero': 'De Zero a Herói',
  'Abrir Análisis': 'Abrir Análise',
  'Abrir Aperturas': 'Abrir Aberturas',
  'Abrir Coordenadas': 'Abrir Coordenadas',
  'Abrir Ejercicios': 'Abrir Exercícios',
  'Abrir Estudios': 'Abrir Estudos',
  'Abrir el editor': 'Abrir o editor',
  'Ir a Jugar': 'Ir para Jogar',
  'Continuar': 'Continuar',
  'Empezar': 'Começar',
  'Cúmplelo antes de pasar al siguiente nivel.': 'Cumpra-o antes de passar ao próximo nível.',
  'Hito del nivel': 'Marco do nível',
  'Inicia sesión': 'Entre',
  'Juegan las blancas.': 'Jogam as brancas.',
  'Juegan las negras.': 'Jogam as pretas.',
  'Lección {n}': 'Lição {n}',
  'Nivel {n}': 'Nível {n}',
  'Progreso': 'Progresso',
  'Reintentar': 'Tentar de novo',
  'Ruta': 'Trilha',
  'Sin sesión, el progreso se guarda en este navegador.': 'Sem sessão, o progresso fica salvo neste navegador.',
  'Solución:': 'Solução:',
  'Ver solución': 'Ver solução',
  'lecciones': 'lições',
  'para llevarlo a tu cuenta.': 'para levá-lo à sua conta.',
  '{hechas} de {total} lecciones': '{hechas} de {total} lições',
  '{n} min': '{n} min',
  '¡Correcto!': 'Correto!',
  'Anterior': 'Anterior',
  'Completada': 'Concluída',
  'Ejercicio': 'Exercício',
  'En el tablero': 'No tabuleiro',
  'Esa no es la mejor jugada. Vuelve a mirar la posición o pide una pista.': 'Esse não é o melhor lance. Olhe a posição de novo ou peça uma dica.',
  'Esa no es la mejor jugada. Vuelve a mirar la posición.': 'Esse não é o melhor lance. Olhe a posição de novo.',
  'Esa también es buena. Seguimos con la línea principal:': 'Esse também é bom. Seguimos com a linha principal:',
  'Final': 'Final',
  'No es esa. Piénsalo otra vez y elige otra opción.': 'Não é essa. Pense de novo e escolha outra opção.',
  'Observa': 'Observe',
  'Para recordar': 'Para lembrar',
  'Paso {n}': 'Passo {n}',
  'Ocultar ejercicio': "Ocultar exercício",
  'Repetir el ejercicio': "Repetir o exercício",
  'Ahora tú: hecho': "Sua vez: feito",
  'Ahora tú: ponlo en práctica': "Sua vez: ponha em prática",
  'Más práctica': "Mais prática",
  'Ahora tú · ejercicio {n} de {total}': "Sua vez · exercício {n} de {total}",
  'Siguiente ejercicio': "Próximo exercício",
  'Lección guiada': "Lição guiada",
  'Aprende · paso {n} de {total}': "Aprenda · passo {n} de {total}",
  'Ejercicio {n} de {total}': "Exercício {n} de {total}",
  'Ver ejercicios': "Ver exercícios",
  'Atrás': "Voltar",
  'Aprende': "Aprenda",
  'Las flechas del tablero te señalan el movimiento o la idea. Usa los botones de abajo para ver el ejemplo jugada a jugada.': "As setas do tabuleiro indicam o movimento ou a ideia. Use os botões abaixo do tabuleiro para ver o exemplo lance a lance.",
  'Seguir aprendiendo': "Continuar aprendendo",
  'Pruébalo tú': "Experimente você",
  'Listo, seguir leyendo': "Pronto, continuar lendo",
  'Cada concepto tiene su ejercicio: pulsa «Pruébalo tú» bajo el tablero. Para mover, toca la pieza y luego la casilla de destino.': "Cada conceito tem seu exercício: toque em «Experimente você» sob o tabuleiro. Para mover, toque na peça e depois na casa de destino.",
  'Toca la pieza y luego la casilla de destino (o arrástrala).': "Toque na peça e depois na casa de destino (ou arraste).",
  'Pasos': 'Passos',
  'Pista:': 'Dica:',
  'Pregunta': 'Pergunta',
  'Práctica en UAChess': 'Prática no UAChess',
  'Reiniciar': 'Reiniciar',
  'Repetir': 'Repetir',
  'Siguiente': 'Próximo',
  'Siguiente lección': 'Próxima lição',
  'Siguiente paso': 'Próximo passo',
  'Usa las flechas para avanzar jugada a jugada.': 'Use as setas para avançar lance a lance.',
  'Ver pista': 'Ver dica',
  '{n} de 3 estrellas': '{n} de 3 estrelas',
  '{n} niveles · {lecciones} lecciones · unas {horas} h': '{n} níveis · {lecciones} lições · cerca de {horas} h',
  '{n} pasos': '{n} passos',
  '¡Bien! Sigue.': 'Muito bem! Continue.',
  '¡Lección completada!': 'Lição concluída!',
  '¡Perfecto!': 'Perfeito!',
  '¡Resuelto!': 'Resolvido!',
  'Cargando…': 'Carregando…',
  'No se pudo cargar la lección. Comprueba tu conexión.': 'Não foi possível carregar a lição. Verifique sua conexão.',
  'Practícala en el paso {n}': 'Pratique-a no passo {n}',

  // Etiquetas y filtros de estudios
  'Etiquetas': 'Etiquetas',
  'Etiquetas de {name}': 'Etiquetas de {name}',
  'Todos': 'Todos',
  'Lado': 'Lado',
  'Desde qué lado están pensados (el que predomina en sus capítulos)': 'De que lado foram pensados (o que predomina nos capítulos)',
  'Blancas': 'Brancas',
  'Negras': 'Pretas',
  'Ambos lados': 'Ambos os lados',
  'No se pudieron guardar las etiquetas.': 'Não foi possível salvar as etiquetas.',
  'Quitar la etiqueta {tag}': 'Remover a etiqueta {tag}',
  'Añadir etiqueta…': 'Adicionar etiqueta…',
  'Ningún estudio cumple el filtro': 'Nenhum estudo corresponde ao filtro',
  'Quitar filtros': 'Limpar filtros',
  // Pro-Tactics
  'Pro-Tactics': 'Pro-Tactics',
  'Al azar': 'Aleatório',
  'Por tema': 'Por tema',
  'Elegir a mano': 'Escolher manualmente',
  'Amenazas, piezas sobrecargadas, debilidades, la idea de la combinación…': 'Ameaças, peças sobrecarregadas, fraquezas, a ideia da combinação…',
  'Anotado': 'Anotado',
  'Borrar anotación': 'Apagar anotação',
  'Buscar por número, jugador, lugar o nombre': 'Buscar por número, jogador, local ou nome',
  'Diagrama {n}': 'Diagrama {n}',
  'Entra para usar Pro-Tactics': 'Entre para usar o Pro-Tactics',
  'Grupo': 'Grupo',
  'Guardado': 'Salvo',
  'Los diagramas de la Enciclopedia de combinaciones. Describe qué sucede en cada posición y ponle un nombre.': 'Os diagramas da Enciclopédia de combinações. Descreva o que acontece em cada posição e dê um nome a ela.',
  'Ningún diagrama cumple el filtro': 'Nenhum diagrama corresponde ao filtro',
  'Ocultar solución': 'Ocultar solução',
  'Partida sin nombres': 'Partida sem nomes',
  'Por ejemplo: sacrificio en h7 y mate con torre': 'Por exemplo: sacrifício em h7 e mate de torre',
  'Primera jugada': 'Primeiro lance',
  'Última jugada': 'Último lance',
  'Pro-Tactics es solo para cuentas VIP': 'O Pro-Tactics é só para contas VIP',
  'Sin guardar': 'Não salvo',
  'Solo los que he anotado': 'Só os que anotei',
  'Tema': 'Tema',
  'Todos los grupos': 'Todos os grupos',
  'Todos los temas': 'Todos os temas',
  'Ver solución del libro': 'Ver a solução do livro',
  'Volver a la lista': 'Voltar à lista',
  '{desde}–{hasta} de {total}': '{desde}–{hasta} de {total}',
  '{hechos} de {total} anotados': '{hechos} de {total} anotados',
  '¿Borrar tu anotación de este diagrama?': 'Apagar sua anotação deste diagrama?',
  '¿Qué sucede en la posición?': 'O que acontece na posição?',
  'Destrucción de la defensa': 'Destruição da defesa',
  'Bloqueo': 'Bloqueio',
  'Liberación de espacio': 'Liberação de espaço',
  'Desviación': 'Desvio',
  'Ataque descubierto': 'Ataque descoberto',
  'Clavada': 'Cravada',
  'Demolición de la estructura de peones': 'Demolição da estrutura de peões',
  'Atracción': 'Atração',
  'Intercepción': 'Interceptação',
  'Doble ataque': 'Ataque duplo',
  'Con ataque al rey': 'Com ataque ao rei',
  'Para lograr la igualdad': 'Para alcançar a igualdade',
  'Otras combinaciones': 'Outras combinações',
  'Bloqueado': 'Bloqueado',
  'Bloquear': 'Bloquear',
  'Bloquear: mueve y prueba líneas sin que se guarden': 'Bloquear: mova e teste linhas sem que sejam salvas',
  'Desbloquear: lo que muevas volverá a guardarse': 'Desbloquear: o que você mover voltará a ser salvo',
  'Borrar desde esta jugada': 'Apagar a partir deste lance',
  'Borrar jugada': 'Apagar lance',
  'Buscar ejercicios': 'Buscar exercícios',
  'Buscar por el nombre que les pusiste…': 'Buscar pelo nome que você deu…',
  'Convertir en línea principal': 'Tornar linha principal',
  'Línea principal': 'Linha principal',
  'Girar el tablero': 'Girar o tabuleiro',
  'Motor de análisis': 'Motor de análise',
  'Motor': 'Motor',
  'Mueve en el tablero para abrir variantes y dibuja flechas con el botón derecho. Se guarda en tu cuenta.': 'Mova no tabuleiro para abrir variantes e desenhe setas com o botão direito. Fica salvo na sua conta.',
  'No se pudo guardar': 'Não foi possível salvar',
  'Profundidad {n}': 'Profundidade {n}',
  'Solución del libro': 'Solução do livro',
  '¿Volver a la solución del libro? Se borran tus variantes y flechas.': 'Voltar à solução do livro? Suas variantes e setas serão apagadas.',
  'Modo práctica: mueve sin miedo, nada se guarda. Las líneas nuevas salen en amarillo; al final de cada una puedes incluirla en tu análisis.': 'Modo prática: mova à vontade, nada é salvo. As linhas novas aparecem em amarelo; no fim de cada uma você pode incluí-la na sua análise.',

  // Pro-Endgames
  'Pro-Endgames': 'Pro-Endgames',
  'Entra para usar Pro-Endgames': 'Entre para usar o Pro-Endgames',
  'Pro-Endgames es solo para cuentas VIP': 'O Pro-Endgames é só para contas VIP',
  'Los diagramas de Comprehensive Chess Endings, de Averbakh. Describe qué sucede en cada posición y ponle un nombre.': 'Os diagramas de Comprehensive Chess Endings, de Averbakh. Descreva o que acontece em cada posição e dê um nome a ela.',
  'Finales de alfil y de caballo': 'Finais de bispo e de cavalo',
  'Alfil contra caballo y torre contra pieza menor': 'Bispo contra cavalo e torre contra peça menor',
  'Otros finales': 'Outros finais',
  'Finales de peones': 'Finais de peões',
  'Finales de torre': 'Finais de torre',
  'Por tomo': 'Por volume',
  'Tomo': 'Volume',
  'Todos los tomos': 'Todos os volumes',
  'Tomo {n}': 'Volume {n}',
  'Por ejemplo: oposición y entrada del rey por d5': 'Por exemplo: oposição e entrada do rei por d5',
  'Plan, casillas clave, oposición, zugzwang, victoria o tablas…': 'Plano, casas-chave, oposição, zugzwang, vitória ou empate…',
  'Diagrama {n} del tomo {v}': 'Diagrama {n} do volume {v}',
  'página {p}': 'página {p}',

  // Entrenador de estudios
  'Este estudio todavía no tiene líneas con jugadas tuyas. Añade jugadas al estudio para poder entrenarlas.': 'Este estudo ainda não tem linhas com lances seus. Adicione lances ao estudo para treiná-las.',
  '{n} de {total} líneas dominadas': '{n} de {total} linhas dominadas',
  '{n} por repasar': '{n} para revisar',
  'Orden': 'Ordem',
  'Las flojas primero': 'As mais fracas primeiro',
  'En el orden del estudio': 'Na ordem do estudo',
  'Línea completa, sin errores.': 'Linha completa, sem erros.',
  'Línea completa. Errores: {n}. Se repasará pronto.': 'Linha completa. Erros: {n}. Voltará em breve.',
  'Línea completa, pero con ayuda. Se repasará pronto.': 'Linha completa, mas com ajuda. Voltará em breve.',
  '{san} no es la jugada del estudio. Prueba otra.': '{san} não é o lance do estudo. Tente outro.',
  'Tu turno: juega la jugada del estudio.': 'Sua vez: jogue o lance do estudo.',
  'Responde la máquina…': 'A máquina está respondendo…',
  'Pista': 'Dica',
  'Mostrar la jugada': 'Mostrar o lance',
  'Empezar de nuevo': 'Recomeçar',
  'Siguiente línea': 'Próxima linha',
  'Seguir contra la máquina': 'Continuar contra a máquina',
  'Marcar esta posición como clave para entrenarla aparte': 'Marcar esta posição como chave para treiná-la à parte',
  'Posición clave': 'Posição-chave',
  'Marcar como clave': 'Marcar como chave',
  'Mostrar los comentarios del estudio': 'Mostrar os comentários do estudo',
  'Líneas': 'Linhas',
  'Dominada': 'Dominada',
  'En aprendizaje': 'Aprendendo',
  'Nueva': 'Nova',
  'Todavía no has marcado ninguna posición. En el repaso de líneas, pulsa «Marcar como clave».': 'Você ainda não marcou nenhuma posição. Na revisão de linhas, clique em “Marcar como chave”.',
  'No hay posiciones clave en este alcance: aparecen donde el estudio ofrece varias opciones, comentarios o jugadas destacadas.': 'Não há posições-chave aqui: aparecem onde o estudo oferece várias opções, comentários ou lances destacados.',
  'Ver todas las posiciones clave': 'Ver todas as posições-chave',
  '{n} de {total} dominadas': '{n} de {total} dominadas',
  'Solo las que he marcado': 'Só as que marquei',
  'Quitar la marca': 'Remover a marca',
  '¿Qué idea hay en esta posición?': 'Qual é a ideia nesta posição?',
  'Plan, amenazas, por qué esta jugada y no otra… (se guarda en tu cuenta)': 'Plano, ameaças, por que este lance e não outro… (salvo na sua conta)',
  'Esta volverá pronto.': 'Esta voltará em breve.',
  '¡Correcto! Jugada del estudio.': 'Correto! Lance do estudo.',
  'Juega la jugada del estudio, o escribe tu idea y mira la solución.': 'Jogue o lance do estudo, ou escreva sua ideia e veja a solução.',
  'Solución del estudio': 'Solução do estudo',
  'línea principal': 'linha principal',
  'alternativa': 'alternativa',
  'Cualquiera de ellas cuenta como acierto.': 'Qualquer uma delas conta como acerto.',
  'Jaque mate: ha ganado la máquina.': 'Xeque-mate: a máquina ganhou.',
  '¡Jaque mate! Has ganado.': 'Xeque-mate! Você ganhou.',
  'Tablas.': 'Empate.',
  'Capítulo': 'Capítulo',
  'Nivel de la máquina': 'Nível da máquina',
  'Has llegado al final del estudio. A partir de aquí juega la máquina: aplica lo aprendido.': 'Você chegou ao fim do estudo. A partir daqui a máquina joga: aplique o que aprendeu.',
  'Estás dentro del estudio.': 'Você está dentro do estudo.',
  'Te saliste del estudio con {san}; el estudio seguía con {expected}.': 'Você saiu do estudo com {san}; o estudo seguia com {expected}.',
  'Fuera del estudio: juega la máquina.': 'Fora do estudo: a máquina joga.',
  'Pensando…': 'Pensando…',
  'Deshacer': 'Desfazer',
  'Ver la jugada del estudio': 'Ver o lance do estudo',
  'Jugar con el otro color': 'Jogar com a outra cor',
  'Cambiar de color': 'Trocar de cor',
  'Jugadas': 'Lances',
  'Aún no hay jugadas.': 'Ainda não há lances.',
  'Las jugadas en gris ya no son del estudio.': 'Os lances em cinza já não são do estudo.',
  'No se pudo cargar el estudio.': 'Não foi possível carregar o estudo.',
  'Ver todos los estudios': 'Ver todos os estudos',
  'Volver al estudio': 'Voltar ao estudo',
  'Entrenar': 'Treinar',
  'Repasa las líneas contra la máquina, practica las posiciones clave y juega desde el estudio hasta dominarlo.': 'Revise as linhas contra a máquina, pratique as posições-chave e jogue a partir do estudo até dominá-lo.',
  'Capítulos': 'Capítulos',
  'Todo el estudio': 'Todo o estudo',
  'Repasar líneas': 'Revisar linhas',
  'Posiciones clave': 'Posições-chave',
  'Contra la máquina': 'Contra a máquina',
  'Este estudio no tiene capítulos.': 'Este estudo não tem capítulos.',
  'Entrenar este estudio': 'Treinar este estudo',
  'Entrenar {name}': 'Treinar {name}',
  'Entrenar las líneas y posiciones clave con la máquina': 'Treinar as linhas e posições-chave com a máquina',
  'Hay varias opciones': 'Várias opções',
  'Con explicación': 'Com explicação',
  'Jugada destacada': 'Lance destacado',
  'Marcada por ti': 'Marcada por você',
  'Principiante': 'Iniciante',
  'Aficionado': 'Amador',
  'De club': 'De clube',
  'Fuerte': 'Forte',
  'Desbloquear: lo que muevas volverá a guardarse en el estudio': 'Desbloquear: o que você mover voltará a ser salvo no estudo',
  'Bloquear: mueve y prueba líneas sin que se guarden en el estudio': 'Bloquear: mova e teste linhas sem salvá-las no estudo',
  'Modo práctica: mueve sin miedo, las jugadas salen en amarillo y no se guardan en el estudio.': 'Modo prática: mova sem medo, os lances aparecem em amarelo e não são salvos no estudo.',
  'Desbloqueado: las jugadas que hagas se guardan en el estudio.': 'Desbloqueado: os lances que você fizer são salvos no estudo.',
  'Siguiente jugada': 'Próximo lance',
  'Ver la jugada': 'Ver o lance',
  'Otro ejemplo': 'Outro exemplo',
  'Siguiente idea': 'Próxima ideia',
  'Juegan blancas': 'Jogam as brancas',
  'Juegan negras': 'Jogam as pretas',
  'Idea {n} de {total}': 'Ideia {n} de {total}',
  'Ejemplos': 'Exemplos',
  'Ejemplo {n}': 'Exemplo {n}',
  'Ya lo has visto': 'Você já viu',
  'Material': 'Material',
  'blancas': 'brancas',
  'negras': 'pretas',
  'igualados': 'igualados',
  '{bando} con {n} de ventaja': '{bando} com {n} de vantagem',
  // Portada
  'O resuelve un ejercicio sin registrarte': 'Ou resolva um exercício sem se registrar',
  'Morphy contra el duque de Brunswick y el conde Isouard, París 1858': 'Morphy contra o duque de Brunswick e o conde Isouard, Paris 1858',
  '17. Td8#': '17. Td8#',

  // Portada con sesión (panel)
  '{n} en vivo': '{n} ao vivo',
  'Ahora mismo no hay partidas en directo.': 'Não há partidas ao vivo agora.',
  'Amigos conectados': 'Amigos online',
  'Buscar o invitar amigos': 'Procurar ou convidar amigos',
  'Duración {n} min': 'Duração {n} min',
  'En directo': 'Ao vivo',
  'En juego': 'Em andamento',
  'En línea': 'Online',
  'En {n} min': 'Em {n} min',
  'Estable': 'Estável',
  'Juegan {side}': 'Jogam as {side}',
  'Jugadas recientes': 'Lances recentes',
  'Más ritmos': 'Mais ritmos',
  'Ninguno de tus amigos está conectado ahora.': 'Nenhum dos seus amigos está online agora.',
  'No hay torneos programados ahora mismo.': 'Não há torneios programados agora.',
  'Próximos torneos': 'Próximos torneios',
  'Racha de táctica': 'Sequência de táticas',
  'Resueltos esta semana': 'Resolvidos esta semana',
  'Resuelve ejercicios cada día para que la semana quede completa.': 'Resolva exercícios todos os dias para completar a semana.',
  'Retar': 'Desafiar',
  'Récord: {n}': 'Recorde: {n}',
  'Sala de espera': 'Sala de espera',
  'Sala de espera ({n} reto)': 'Sala de espera ({n} desafio)',
  'Sala de espera ({n} retos)': 'Sala de espera ({n} desafios)',
  'Sin jugadas todavía.': 'Ainda sem lances.',
  'Terminada': 'Terminada',
  'Unirse': 'Entrar',
  'Ver en UAChess TV': 'Ver na UAChess TV',
  'Ver la partida': 'Ver a partida',
  'Ver todo': 'Ver tudo',
  '{d} esta semana': '{d} esta semana',
  '{n} acierto': '{n} acerto',
  '{n} aciertos': '{n} acertos',
  '{n} conectado': '{n} online',
  '{n} conectados': '{n} online',
  '{n} en línea': '{n} online',
  '{n} inscrito': '{n} inscrito',
  '{n} inscritos': '{n} inscritos',
  '{n} jugador conectado': '{n} jogador online',
  '{n} jugadores conectados': '{n} jogadores online',
  '{n} partida': '{n} partida',
  '{n} partidas': '{n} partidas',
  '{n} partida en juego': '{n} partida em andamento',
  '{n} partidas en juego': '{n} partidas em andamento',
  'Buenos días, {name}': 'Bom dia, {name}',
  'Buenas tardes, {name}': 'Boa tarde, {name}',
  'Buenas noches, {name}': 'Boa noite, {name}',
  'Sin cambios esta semana': 'Sem mudanças esta semana',
  'acierto seguido': 'acerto seguido',
  'aciertos seguidos': 'acertos seguidos',
  'Ajedrez completo y sin anuncios': 'Xadrez completo e sem anúncios',
  'Experiencia de gran maestro': 'Uma experiência de grande mestre',
  'Análisis de gran maestro con Stockfish': 'Análise de grande mestre com Stockfish',
  // Torneos, Comunidades y TV
  'Estado': 'Estado',
  'Minutos': 'Minutos',
  'Incremento (s)': 'Incremento (s)',
  'Torneos de ajedrez': 'Torneios de xadrez',
  'Arenas en vivo, torneos suizos y eliminatorias en tiempo real': 'Arenas ao vivo, torneios suíços e eliminatórias em tempo real',
  'Refrescar lista': 'Atualizar lista',
  'Crear torneo': 'Criar torneio',
  'Entra para participar': 'Entre para participar',
  'Próximos': 'Próximos',
  'Finalizados': 'Encerrados',
  'Actualización automática': 'Atualização automática',
  'Buscar torneo por nombre, club o ganador...': 'Buscar por nome, clube ou vencedor…',
  'Formato: Todos': 'Formato: todos',
  'Arenas': 'Arenas',
  'Suizos': 'Suíços',
  'Eliminatorias': 'Eliminatórias',
  'Ritmo: Todos': 'Ritmo: todos',
  'Bala': 'Bullet',
  'Clásica': 'Clássica',
  'Acceso: Todos': 'Acesso: todos',
  'Públicos': 'Públicos',
  'Privados con clave': 'Privados com senha',
  'Con filtros de entrada': 'Com requisitos de entrada',
  'Limpiar filtros': 'Limpar filtros',
  'Limpiar': 'Limpar',
  'Cargando torneos...': 'Carregando torneios…',
  'En juego ahora': 'Em andamento agora',
  'Empieza pronto': 'Começa em breve',
  'Puntuable': 'Valendo rating',
  'jugador inscrito': 'jogador inscrito',
  'jugadores inscritos': 'jogadores inscritos',
  'Club: {name}': 'Clube: {name}',
  'Tiempo restante': 'Tempo restante',
  'Comienza en': 'Começa em',
  'En curso': 'Em andamento',
  'Entrar a jugar': 'Jogar',
  'Inscribirme': 'Inscrever-me',
  'Terminado': 'Encerrado',
  '{n} rondas': '{n} rodadas',
  'Amistoso': 'Amistoso',
  'Amistosa': 'Amistosa',
  'solo miembros': 'só membros',
  'Campeón:': 'Campeão:',
  'Duración: {n} min': 'Duração: {n} min',
  'Resultados': 'Resultados',
  'No se encontraron torneos': 'Nenhum torneio encontrado',
  'No hay torneos que coincidan con la búsqueda o los filtros aplicados.': 'Nenhum torneio corresponde à busca ou aos filtros.',
  'No hay torneos programados próximamente': 'Não há torneios programados',
  'Sé el primero en crear uno. Puedes elegir el ritmo, duración y condiciones que prefieras.': 'Seja o primeiro a criar um. Você escolhe o ritmo, a duração e as condições.',
  'No hay torneos en juego ahora mismo': 'Nenhum torneio em andamento agora',
  'Consulta los próximos torneos para apuntarte o crea tu propia sala.': 'Veja os próximos torneios para se inscrever ou crie o seu.',
  'Aún no hay torneos finalizados': 'Ainda não há torneios encerrados',
  'Cuando se completen competiciones en la plataforma, aquí podrás consultar sus podios e historiales.': 'Quando os torneios terminarem, você verá aqui os pódios e resultados.',
  'No hay torneos registrados': 'Ainda não há torneios',
  'Crea el primer torneo de la comunidad.': 'Crie o primeiro torneio da comunidade.',
  'Privado con clave': 'Privado com senha',
  'Privado': 'Privado',
  'Femenino': 'Feminino',
  'Masculino': 'Masculino',
  '{min}–{max} años': '{min}–{max} anos',
  '≥ {n} partidas': '≥ {n} partidas',
  'Arena de UAChess': 'Arena da UAChess',
  'Indica cuándo empieza.': 'Indique quando começa.',
  'No se pudo crear el torneo.': 'Não foi possível criar o torneio.',
  'Torneo exclusivo para miembros del club': 'Torneio exclusivo para membros do clube',
  'Organiza una competición para la comunidad': 'Organize uma competição para a comunidade',
  'Nombre del torneo': 'Nome do torneio',
  'Descripción y normas (opcional)': 'Descrição e regras (opcional)',
  'Premios, normas, a quién va dirigido…': 'Prêmios, regras, para quem é…',
  'Formato de competición': 'Formato',
  'Ritmo de juego': 'Ritmo de jogo',
  'Duración total (minutos)': 'Duração total (minutos)',
  'Número de rondas': 'Número de rodadas',
  'Fecha y hora de inicio': 'Data e hora de início',
  'Las partidas cuentan para el rating oficial': 'As partidas contam para o rating',
  'Permitir berserk (jugar con la mitad del tiempo por 1 punto extra)': 'Permitir berserk (jogar com metade do tempo por 1 ponto extra)',
  'Condiciones y filtros de entrada': 'Requisitos de entrada',
  'Opcional': 'Opcional',
  'Acceso y privacidad': 'Acesso e privacidade',
  'Público': 'Público',
  'Contraseña de acceso': 'Senha de acesso',
  'Ej. ajedrez2026 (requerida para apuntarse)': 'Ex.: xadrez2026 (necessária para entrar)',
  'Solo los jugadores que introduzcan esta clave podrán entrar al torneo.': 'Só quem digitar esta senha poderá entrar no torneio.',
  'Límite de Elo': 'Limite de rating',
  'Elo mínimo': 'Rating mínimo',
  'Sin mínimo': 'Sem mínimo',
  'Elo máximo': 'Rating máximo',
  'Sin máximo': 'Sem máximo',
  'Categoría de género / sexo': 'Categoria de gênero',
  'Categoría por edad': 'Categoria por idade',
  'Todas las edades (Sin límite)': 'Todas as idades (sem limite)',
  'Sub-10 (Hasta 10 años)': 'Sub-10 (até 10 anos)',
  'Sub-12 (Hasta 12 años)': 'Sub-12 (até 12 anos)',
  'Sub-14 (Hasta 14 años)': 'Sub-14 (até 14 anos)',
  'Sub-16 (Hasta 16 años)': 'Sub-16 (até 16 anos)',
  'Sub-18 (Hasta 18 años)': 'Sub-18 (até 18 anos)',
  'Senior +50 (A partir de 50 años)': 'Sênior +50 (a partir de 50 anos)',
  'Senior +65 (A partir de 65 años)': 'Sênior +65 (a partir de 65 anos)',
  'Personalizado (definir edades)...': 'Personalizado (definir idades)…',
  'Edad mínima': 'Idade mínima',
  'Ej. 18': 'Ex.: 18',
  'Edad máxima': 'Idade máxima',
  'Ej. 30': 'Ex.: 30',
  'Partidas jugadas en la plataforma': 'Partidas jogadas na plataforma',
  'Filtro anti-smurfs': 'Filtro contra contas falsas',
  'Solo podrán entrar los miembros del club.': 'Só membros do clube poderão entrar.',
  'Creando…': 'Criando…',
  'Crear y entrar': 'Criar e entrar',
  'Hoy a las {time}': 'Hoje às {time}',
  'Mañana a las {time}': 'Amanhã às {time}',
  'Ayer a las {time}': 'Ontem às {time}',
  '{date} a las {time}': '{date} às {time}',
  '¡Comenzando ahora!': 'Começando agora!',
  'En {m}m {s}s': 'Em {m}m {s}s',
  'En {n} h': 'Em {n} h',
  'En {n} días': 'Em {n} dias',
  '{n} torneo registrado': '{n} torneio',
  '{n} torneos registrados': '{n} torneios',
  '{n} jugador': '{n} jogador',
  '{n} jugadores': '{n} jogadores',
  'Arena': 'Arena',
  'Emparejamiento continuo': 'Emparceiramento contínuo',
  'Suizo': 'Suíço',
  'Rondas fijas': 'Rodadas fixas',
  'Eliminatoria': 'Eliminatória',
  'Quien pierde, fuera': 'Quem perde, sai',
  'Abierto': 'Aberto',
  'Sub-1500': 'Sub-1500',
  'Sub-1800': 'Sub-1800',
  'Sub-2000': 'Sub-2000',
  'Personalizado': 'Personalizado',
  'Abierto a todos': 'Aberto a todos',
  '♀ Femenino': '♀ Feminino',
  'Solo mujeres': 'Só mulheres',
  '♂ Masculino': '♂ Masculino',
  'Solo hombres': 'Só homens',
  '≥ 5 partidas': '≥ 5 partidas',
  '≥ 10 partidas': '≥ 10 partidas',
  '≥ 20 partidas': '≥ 20 partidas',
  '≥ 50 partidas': '≥ 50 partidas',
  'Clubes y asociaciones de UAChess': 'Clubes e associações da UAChess',
  'Comunidades de UAChess': 'Comunidades da UAChess',
  'Únete a un club oficial, compite en ligas con ascensos y descensos, disputa torneos inter-clubes y forja tu legado en la clasificación interna.': 'Entre num clube, dispute ligas com acesso e rebaixamento, jogue torneios entre clubes e suba na classificação interna.',
  'Cerrar formulario': 'Fechar formulário',
  'Crear club o asociación': 'Criar clube ou associação',
  'Entra para crear tu club': 'Entre para criar seu clube',
  'Ligas privadas': 'Ligas privadas',
  'Por temporadas': 'Por temporada',
  'Suizo y arena': 'Suíço e arena',
  'Elo interno': 'Rating interno',
  'Asociaciones': 'Associações',
  'Federaciones': 'Federações',
  'Todas las comunidades': 'Todas as comunidades',
  'Mis clubes': 'Meus clubes',
  'Clubes': 'Clubes',
  'Buscar asociaciones…': 'Buscar associações…',
  'Buscar clubes…': 'Buscar clubes…',
  'Buscar por nombre o descripción…': 'Buscar por nome ou descrição…',
  'Limpiar búsqueda': 'Limpar busca',
  'No se encontraron comunidades': 'Nenhuma comunidade encontrada',
  'No perteneces a ninguna asociación': 'Você não está em nenhuma associação',
  'Aún no hay asociaciones federadas registradas': 'Ainda não há associações',
  'Aún no formas parte de ningún club': 'Você ainda não faz parte de nenhum clube',
  'Aún no hay clubes de ajedrez registrados': 'Ainda não há clubes de xadrez',
  'No hay coincidencias para «{query}». Prueba con otros términos o crea una nueva comunidad.': 'Nada corresponde a «{query}». Tente outros termos ou crie uma comunidade.',
  'Los clubes tienen sus propios torneos, ligas por temporadas con ascensos y descensos, y una clasificación interna independiente del rating global.': 'Os clubes têm torneios próprios, ligas por temporada com acesso e rebaixamento e uma classificação interna separada do rating geral.',
  'Crear la primera comunidad': 'Criar a primeira comunidade',
  'Asociación': 'Associação',
  'Club oficial': 'Clube',
  'Comunidad de ajedrez en UAChess.': 'Comunidade de xadrez na UAChess.',
  'Tuya': 'Sua',
  'Tu club': 'Seu clube',
  'Miembro': 'Membro',
  'Ver club': 'Ver',
  'Indica un nombre para la comunidad.': 'Dê um nome à comunidade.',
  'No se pudo crear la comunidad.': 'Não foi possível criar a comunidade.',
  'Nueva asociación': 'Nova associação',
  'Nuevo club de ajedrez': 'Novo clube de xadrez',
  'Configura los detalles principales de tu comunidad oficial.': 'Configure os detalhes principais da sua comunidade.',
  'Tipo de comunidad': 'Tipo de comunidade',
  'Nombre de la asociación': 'Nome da associação',
  'Nombre del club': 'Nome do clube',
  'Asociación de Ajedrez de Madrid': 'Associação de Xadrez de Lisboa',
  'Club de Ajedrez Kasparov': 'Clube de Xadrez Kasparov',
  'Descripción de la comunidad': 'Descrição da comunidade',
  'Quiénes somos, días de juego, torneos y eventos que organizamos…': 'Quem somos, dias de jogo, torneios e eventos que organizamos…',
  'Emblema del club': 'Emblema do clube',
  'Emblema actual: {emblem}. Pulsa para cambiarlo': 'Emblema atual: {emblem}. Toque para mudar',
  'Elige un emoji representativo': 'Escolha um emoji que represente vocês',
  'Podrás personalizar el fondo y subir una foto desde la configuración.': 'Depois você pode mudar o fundo e enviar uma foto nas configurações.',
  'Política de admisión': 'Quem pode entrar',
  'Crear asociación': 'Criar associação',
  'Crear club': 'Criar clube',
  '{n} miembro': '{n} membro',
  '{n} miembros': '{n} membros',
  'Por solicitud': 'Por solicitação',
  'Por invitación': 'Por convite',
  'Club de ajedrez': 'Clube de xadrez',
  'Comunidad de jugadores, torneos y ligas': 'Jogadores, torneios e ligas',
  'Asociación federada': 'Associação',
  'Agrupa jugadores y clubes afiliados': 'Reúne jogadores e clubes afiliados',
  'Cualquiera entra directamente': 'Qualquer pessoa entra direto',
  'El administrador aprueba': 'Um administrador aprova',
  'Solo miembros invitados': 'Só membros convidados',
  'Buscando partidas en directo': 'Procurando partidas ao vivo',
  'Canal': 'Canal',
  'Cuadrícula': 'Grade',
  'Repetición en tiempo real': 'Reprise em tempo real',
  'Cargando Stockfish…': 'Carregando o Stockfish…',
  'Evaluación en directo': 'Avaliação ao vivo',
  'profundidad {n}': 'profundidade {n}',
  'quitar': 'ocultar',
  'Mostrar la evaluación de Stockfish': 'Mostrar a avaliação do Stockfish',
  'Repetición': 'Reprise',
  'Partida terminada. Buscando la siguiente…': 'Partida encerrada. Procurando a próxima…',
  'Juegan blancas.': 'Jogam as brancas.',
  'Juegan negras.': 'Jogam as pretas.',
  'Ver la partida completa': 'Ver a partida completa',
  'Acaba de empezar.': 'Acabou de começar.',
  'No hay nada en directo en este canal': 'Nada ao vivo neste canal',
  'UAChess TV muestra las partidas más interesantes que se están jugando ahora mismo. En cuanto empiece una, aparecerá aquí sola.': 'A UAChess TV mostra as partidas mais interessantes que estão sendo jogadas agora. Assim que uma começar, ela aparece aqui.',
  'Top Rating': 'Melhores ratings',
  'Simultáneas': 'Simultâneas',
  'Correspondencia': 'Correspondência',
  // Avisos al móvil
  'Avisos en este dispositivo': 'Notificações neste dispositivo',
  'No se han podido activar. Vuelve a intentarlo.': 'Não foi possível ativá-las. Tente de novo.',
  'En iPhone y iPad, primero añade UAChess a la pantalla de inicio (Compartir → Añadir a inicio) y ábrela desde ahí.': 'No iPhone e iPad, primeiro adicione o UAChess à tela de início (Compartilhar → Adicionar à Tela de Início) e abra por lá.',
  'Los has bloqueado en el navegador. Permite las notificaciones de este sitio desde los ajustes del navegador.': 'Você as bloqueou no navegador. Permita as notificações deste site nas configurações do navegador.',
  'Este navegador no admite avisos.': 'Este navegador não aceita notificações.',
  'Te avisamos cuando te toca en una partida por correspondencia, te retan, empieza tu torneo o te escriben. Solo en este dispositivo.': 'Avisamos quando for sua vez numa partida por correspondência, quando desafiarem você, quando seu torneio começar ou quando escreverem para você. Só neste dispositivo.',
  'Recibir estos avisos en el móvil': 'Receber estes avisos no celular',
};

export default pt;
